<template>
  <ankh-list :showSearchForm="false">
    <template #btn-group>
      <el-button @click.native="handleShowDialog()">{{$t('新增')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #table="{height}">
      <table-list
          ref="list"
          row-key="id"
          :height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          :indent="16"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" :label="$t('序号')" width="50" fixed />

        <el-table-column prop="name" :label="$t('名称')" fixed />
        <el-table-column prop="rate" :label="$t('抽佣比例')" />
        <el-table-column prop="flag" :label="$t('标识')" />
        <el-table-column prop="status" :label="$t('状态')">
          <template v-slot="{row}">
            <DictText :status="row.status" dict-flag="OPEN_OR_CLOSE" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('创建时间')">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" min-width="40">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="handleShowDialog(row)">{{$t('编辑')}}</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template #other>
      <el-dialog :title="isEdit ? $t('编辑') : $t('新增')" :visible.sync="showDialog" :close-on-click-modal="false" width="500px">
        <el-form :model="formData" label-width="auto" :rules="rules" ref="form">
          <el-form-item :label="$t('名称')" prop="name">
            <el-input :placeholder="$t('请输入名称')" v-model="formData.name" />
          </el-form-item>
          <el-form-item :label="$t('标识')" prop="flag">
            <el-input :placeholder="$t('请输入标识')" v-model="formData.flag" />
          </el-form-item>
          <el-form-item :label="$t('抽佣比例')" prop="rate">
            <el-input :placeholder="$t('请输入抽佣比例')" v-model="formData.rate">
              <template #append>%</template>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('状态')" prop="status">
            <el-switch v-model="formData.status" inactive-value="close" active-value="open" />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button type="primary" @click="handleSubmit">{{$t('保存')}}</el-button>
          <el-button @click="showDialog = false">{{$t('取消')}}</el-button>
        </template>
      </el-dialog>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import AnkhList from "@/components/list/AnkhList.vue";
import DictText from "@/components/dict/DictText.vue"

export default {
  name: "PayFeeList",
  components: {AnkhList, TableList, DictText},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      currentRow: {},
      isEdit: false,

      formData: {
        status: "open"
      },
      showDialog: false,
      rules: {
        name: {required: true, message: this.$t('请输入名称'), trigger: 'blur'},
        flag: {required: true, message: this.$t('请输入标识'), trigger: 'blur'},
        rate: {required: true, message: this.$t('请输入抽佣比例'), trigger: 'blur'},
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if(!valid) return;
        try {
          const action = this.isEdit ? this.$api.payFee.update : this.$api.payFee.add;
          await request(action, this.formData);
          this.$refs.list.handleRequest();
          this.$message.success(this.$t("操作成功"));
          this.showDialog = false;
        } catch (err) {
          console.error(err);
        }
      })
    },

    handleShowDialog(row) {
      if(row) {
        this.isEdit = true;
        this.formData = {
          ...row,
        }
      } else {
        this.isEdit = false;
        this.formData = {status: "open"};
      }
      this.showDialog = true
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.payFee.delete, {code: row.code});
        this.$message.success(this.$t("操作成功"))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t("未选择记录")
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.payFee.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t("您现在正在进行批量删除操作, 是否继续?")}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();

      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.payFee.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>


</style>
